import { LAYOUT_XS, LAYOUT_SM, LAYOUT_MD, LAYOUT_LG } from "./../../settings"

import logoDefault from "./assets/logo.svg";
import logoWhite from "./assets/logo-white.svg";
import logoPlus from "./assets/logo-plus.svg";
import logoIcon from "./assets/logo-icon.svg";
import placeholderDefault from "./assets/placeholder.svg";
import placeholderUser from "./assets/user-placeholder.jpg";
import placeholderProduct from "./assets/placeholder.svg";
import placeholderCasehistory from "./assets/placeholder.svg";
import idleImage from "./assets/idlepage.svg";
// import idleImageCompanies from "./assets/idlepage-companies.svg";
// import idleImageProducts from "./assets/idlepage-products.svg";
// import idleImageEvents from "./assets/idlepage-events.svg";
// import idleImageCasehistories from "./assets/idlepage-casehistories.svg";
import faviconImage from "./assets/favicon.ico";


import hallVoid from "./assets/hall-void-2026.svg";
// import hallP1 from "./assets/hall-P1.svg";
// import hallP2 from "./assets/hall-P2.svg";
// import hallP3 from "./assets/hall-P3.svg";
// import hallP4 from "./assets/hall-P4.svg";
// import hallP5 from "./assets/hall-P5.svg";
import hallP6 from "./assets/hall-P6-2026.svg";
import hallP7 from "./assets/hall-P7-2026.svg";
// import hallP8 from "./assets/hall-P8.svg";
import hallP9 from "./assets/hall-P9-2026.svg";
import hallP10 from "./assets/hall-P10-2026.svg";
import hallP11 from "./assets/hall-P11-2026.svg";
import hallP12 from "./assets/hall-P12-2026.svg";
// import hallPA from "./assets/hall-PA.svg";
// import hallPB from "./assets/hall-PB.svg";
// import hallPC from "./assets/hall-PC.svg";
// import hallPD from "./assets/hall-PD.svg";
import hallPE from "./assets/hall-PE-2026.svg";
import hallPF from "./assets/hall-PF-2026.svg";
import hallC from "./assets/hall-C-2026.svg";
import hallC9_11 from "./assets/hall-C9-11r90-2026.svg";
import hallC11_12 from "./assets/hall-C11-12r90-2026.svg";
// import hallCSA from "./assets/hall-CSA.svg";
// import hallCSC from "./assets/hall-CSC.svg";
// import hallCSE from "./assets/hall-CSE.svg";
import hallCSS from "./assets/hall-CSS.svg";
import hallPALAEXPO from "./assets/hall-PALAEXPO.svg";


export const SAM = {
  logo: {
    variant: {
      "default": logoDefault,
      "white": logoWhite,
      "plus": logoPlus,
      "icon": logoIcon,
    }
  },
  halls:{
    "void": hallVoid,
    "6R90": hallP6,
    "7R90": hallP7,
    // "8R90": hallP8,
    "9R90": hallP9,
    "10R90": hallP10,
    "11R90": hallP11,
    "12R90": hallP12,
    "CR90": hallC,
    "C9-11R90": hallC9_11,
    "C11-12R90": hallC11_12,
    // "DR90": hallPD,
    "ER90": hallPE,
    "FR90": hallPF,
    // "G6-7R90": hallCSA,
    "G11-12R90": hallCSS,
    "EXPOINT": hallPALAEXPO
  },
  color: "#ffd300",
  favicon: faviconImage,
  loading:{
    variant: {
      "default": {
        color: "#ffd300"
      }
    }
  },
  placeholder:  placeholderDefault,
  placeholders: {
    default: placeholderDefault,
    user: placeholderUser,
    product: placeholderProduct,
    casehistory: placeholderCasehistory
  },
  background:{
    homepage: "#F5F5F5",
    global: "#F5F5F5"
  },
  icons: {
    set: {
      openFilters: "filters-1",
      closeFilters: "close-1",
      clearFilters: "trash-1",
      backFilters: "arrow-left-2",
      memo: "edit-1",
      contact: "contact-1",
      chat: "chat-1",
      calendar: "calendar-1",
      favorite: "favorite-5",
      homepage: "home-2",
      more: "more-1",
      list: "list-1",
      menuitemPrev: "arrow-left-2",
      menuitemNext: "arrow-right-2",
      language: "language-1",
      chunk: "arrow-bottom-2",
      login: "login-1",
      logout: "logout-1",
      profile: "fieragricola-1",
      checked: "tick-1",
      highlightedPost: "flag-1",
      recommendedPost: "recommended-1",
      timestampPost: "clock-1",
      menu: "menu-1",
      loading: "spinner-1",
      helpdesk: "helpdesk-1",
      legal: "legal",
      complaints: "complaints"
    },
    scale: {
      normal: 0.6,
      wrapped: 0.4
    }
  },
  container: {
    [LAYOUT_XS]: {
      width: {
        value: "calc(100% - 30px)",
        unit: ""
      }
    },
    [LAYOUT_SM]: {
      width: {
        value: "calc(100% - 50px)",
        unit: ""
      }
    },
    [LAYOUT_MD]: {
      width: {
        value: "calc(100% - 50px)",
        unit: ""
      }
    },
    [LAYOUT_LG]: {
      width: {
        value: 990,
        unit: "px"
      }
    }
  },
  slider:{
    dots:{
      size: {
        value: 10,
        unit: "px"
      },
      spacing: {
        value: 10,
        unit: "px"
      },
      borderRadius: {
        value: 0,
        unit: "px"
      },
    },
    arrows:{
      width: {
        value: 40,
        unit: "px"
      },
      height: {
        value: 60,
        unit: "px"
      },
      size: {
        value: 20,
        unit: "px"
      },
      offset: {
        value: 20,
        unit: "px"
      },
      borderRadius: {
        value: 0,
        unit: "px"
      },
    },
    variant: {
      "default": {
        dots:{
          colorActive: "#ffd300",
          colorUnactive: "#dedede"
        },
        arrows:{
          background: "#ffffff",
          color: "#050505",
          border: "#EDEDED"
        }
      }
    }
  },
  userpanel:{
    background: "#202128",
    menuitemVariantBar: "black",
    menuitemVariantItem: "default",
    version: {
      background: "#e6e6e6",
      color: "#999999"
    }
  },
  idlepage:{
    image: {
      companies: idleImage, //idleImageCompanies,
      products: idleImage, //idleImageProducts,
      events: idleImage, //idleImageEvents,
      casehistories: idleImage, //idleImageCasehistories,
      bcards: idleImage,
      chat: idleImage
    }

  },
  topbar:{
    height: {
      value: 60,
      unit: "px"
    },
    background: "#282930",
    borderBottom: "1px solid #4D4D4D",
    boxShadow: "0px 3px 5px #0000000F",
    textColor: "#ffd300",
    badgeVariant: "default",
    buttonVariant: "default",
    enable:{

    },
    logo:{
      variant: "white",
      height: {
        value: 30,
        unit: "px"
      },
      width: {
        value: 105,
        unit: "px"
      },
      alignment: "C", // L C R
    },
    language:{
      borderSize: 2,
      borderStyle: "solid",
      borderColor: "#ffd300",
      color: "#ffd300",
    },
    icon:{
      normal:{
        color: "#ffd300",
        background: null
      },
      hover:{
        color: "#ffd300",
        background: null
      },
      active:{
        color: "#ffd300",
        background: null
      }
    },
    item:{
      padding: {
        top:{
          value: 6,
          unit: "px"
        },
        left:{
          value: 15,
          unit: "px"
        },
        bottom:{
          value: 6,
          unit: "px"
        },
        right:{
          value: 15,
          unit: "px"
        }
      },
      textFont: '"DIN", sans-serif',
      textSize: 20,
      textWeight: 900,
      textLineHeight: null,
      textLetterSpacing: null,
      textTransform: "uppercase",
      borderSize: 0,
      borderStyle: "solid",
      borderRadius: {
        value: 100,
        unit: "px"
      },
      state:{
        normal:{
          textColor: "#ffffff",
          borderColor: "transparent",
          background: "transparent"
        },
        hover:{
          textColor: "#000000",
          borderColor: "transparent",
          background: "#ffd300"
        },
        active:{
          textColor: "#000000",
          borderColor: "transparent",
          background: "#ffd300"
        },
        disabled:{
          textColor: "##0000004d",
          borderColor: "transparent",
          background: "transparent"
        }
      }

    },

    desktop:{
      height: {
        value: 60,
        unit: "px"
      },
      background: "#ffffff",
      textColor: "#000000",
      badgeVariant: "default",
      enable:{
        website: true,
        homeButton: true,
        updateBadge: true
      },
      icon:{
        normal:{
          color: "#ffd300",
          background: null
        },
        hover:{
          color: "#ffd300",
          background: null
        },
        active:{
          color: "#ffd300",
          background: null
        }
      }
    },
    mobile:{
      height: {
        value: 60,
        unit: "px"
      },
      background: "#ffffff",
      textColor: "#000000",
      badgeVariant: "default",
      enable:{
        website: true,
        homeButton: true,
        updateBadge: true
      },
      logo:{
        variant: "default",
        height: {
          value: 40,
          unit: "px"
        },
        width: {
          value: 100,
          unit: "%"
        },
        alignment: "C", // L C R
      },
      icon:{
        normal:{
          color: "#ffd300",
          background: null
        },
        hover:{
          color: "#ffd300",
          background: null
        },
        active:{
          color: "#ffd300",
          background: null
        }
      }
    }
  },
  list:{
    width: {
      value: 380,
      unit: "px"
    },
    levelTransition: 0.3, // in seconds
    background: "#2C2C33",
    textColor: "#ffffff",
    logo:{
      variant: "default",
      height: {
        value: 40,
        unit: "px"
      },
      width: {
        value: 340,
        unit: "px"
      },
      alignment: "C", // L C R
    },
    resultsTab: {
      button: {
        normal: {
          background: "transparent",
          color: "#ffffff"
        },
        active: {
          background: "#FFD300",
          color: "#000000"
        }
      }
    },
    search:{
      borderStyle: "solid",
      borderSize: {
        top: 0,
        left: 0,
        bottom: 0,
        right: 0
      },
      borderColor: "transparent",
      borderRadius: {
        value: 4,
        unit: "px"
      },
      background: "#202128",
      textColor: "#ffffff",
      placeholderColor: "#ffffff",
      icon:{
        normal:{
          color: "#ffd300",
          background: "#202128"
        },
        hover:{
          color: "#202128",
          background: "#ffd300"
        },
        active:{
          color: "#202128",
          background: "#ffd300"
        }
      }
    }
  },
  filters: {
    width: {
      value: 380,
      unit: "px"
    },
    item: {
      menuitemVariant: "filter",
      badgeVariant: "filter"
    },
    search:{
      borderStyle: "solid",
      borderSize: 0,
      borderColor: "transparent",
      borderRadius: {
        value: 4,
        unit: "px"
      },
      background: "#00000066",
      textColor: "#ffffff",
      placeholderColor: "#ffffff",
    },
    bar:{
      iconSize: {
        value: 40,
        unit: "px"
      },
      textSize: 22,
      textColor: "#FFD300",
      textWeight: "600",
      icon:{
        normal:{
          color: "#FFD300",
          background: "transparent"
        },
        hover:{
          color: "#FFD300",
          background: "#ffffff"
        },
        active:{
          color: "#FFD300",
          background: "ffffff"
        }
      }
    },
    tag:{
      icon:{
        color: "#000000"
      }
    },
    background: "#202128",
    buttonVariant: "default-inverse",

  },
  homepage: {
    menuitemVariant: "homepage",
    menuitemSize: "tiny",
    fullsize: true
  },
  actionbar:{
    borderStyle: "solid",
    borderSize: 1,
    borderRadius: {
      value: 4,
      unit: "px"
    },
    variant: {
      "default": {
        normal: {
          textColor: "#585858",
          iconColor: "#d4d4d4",
          borderColor: "#EDEDED",
          background: "#ffffff"
        },
        hover: {
          textColor: "#585858",
          iconColor: "#d4d4d4",
          borderColor: "#ffd300",
          background: "#ffffff"
        },
        active: {
          textColor: "#585858",
          iconColor: "#ffd300",
          borderColor: "#EDEDED",
          background: "#ffffff"
        },
        disabled: {
          textColor: "#58585880",
          iconColor: "#d4d4d480",
          borderColor: "#EDEDED80",
          background: "#ffffff80"
        }
      }
    }
  },
  chunk:{
    borderStyle: "solid",
    borderSize: 0,
    borderRadius: {
      value: 25,
      unit: "px"
    },
    padding:{
      [LAYOUT_XS]: {
        top:{
          value: 20,
          unit: "px"
        },
        left:{
          value: 15,
          unit: "px"
        },
        bottom:{
          value: 0,
          unit: "px"
        },
        right:{
          value: 15,
          unit: "px"
        }
      },
      [LAYOUT_SM]: {
        top:{
          value: 20,
          unit: "px"
        },
        left:{
          value: 15,
          unit: "px"
        },
        bottom:{
          value: 0,
          unit: "px"
        },
        right:{
          value: 15,
          unit: "px"
        }
      },
      [LAYOUT_MD]: {
        top:{
          value: 20,
          unit: "px"
        },
        left:{
          value: 15,
          unit: "px"
        },
        bottom:{
          value: 0,
          unit: "px"
        },
        right:{
          value: 15,
          unit: "px"
        }
      },
      [LAYOUT_LG]: {
        top:{
          value: 20,
          unit: "px"
        },
        left:{
          value: 20,
          unit: "px"
        },
        bottom:{
          value: 0,
          unit: "px"
        },
        right:{
          value: 20,
          unit: "px"
        }
      }
    },
    bar: {
      height: {
        value: 60,
        unit: "px"
      },
      padding:{
        [LAYOUT_XS]: {
          top:{
            value: 0,
            unit: "px"
          },
          left:{
            value: 0,
            unit: "px"
          },
          bottom:{
            value: 15,
            unit: "px"
          },
          right:{
            value: 0,
            unit: "px"
          }
        },
        [LAYOUT_SM]: {
          top:{
            value: 0,
            unit: "px"
          },
          left:{
            value: 0,
            unit: "px"
          },
          bottom:{
            value: 15,
            unit: "px"
          },
          right:{
            value: 0,
            unit: "px"
          }
        },
        [LAYOUT_MD]: {
          top:{
            value: 0,
            unit: "px"
          },
          left:{
            value: 0,
            unit: "px"
          },
          bottom:{
            value: 15,
            unit: "px"
          },
          right:{
            value: 0,
            unit: "px"
          }
        },
        [LAYOUT_LG]: {
          top:{
            value: 0,
            unit: "px"
          },
          left:{
            value: 0,
            unit: "px"
          },
          bottom:{
            value: 20,
            unit: "px"
          },
          right:{
            value: 0,
            unit: "px"
          }
        }
      },
      textFont: null,
      textSize: 22,
      textWeight: 900,
      textLineHeight: null,
      textLetterSpacing: null,
      textTransform: null,
    },
    content: {
      borderStyle: "solid",
      borderSize: 0,
      padding:{
        [LAYOUT_XS]: {
          top:{
            value: 0,
            unit: "px"
          },
          left:{
            value: 0,
            unit: "px"
          },
          bottom:{
            value: 15,
            unit: "px"
          },
          right:{
            value: 0,
            unit: "px"
          }
        },
        [LAYOUT_SM]: {
          top:{
            value: 0,
            unit: "px"
          },
          left:{
            value: 0,
            unit: "px"
          },
          bottom:{
            value: 15,
            unit: "px"
          },
          right:{
            value: 0,
            unit: "px"
          }
        },
        [LAYOUT_MD]: {
          top:{
            value: 0,
            unit: "px"
          },
          left:{
            value: 0,
            unit: "px"
          },
          bottom:{
            value: 15,
            unit: "px"
          },
          right:{
            value: 0,
            unit: "px"
          }
        },
        [LAYOUT_LG]: {
          top:{
            value: 0,
            unit: "px"
          },
          left:{
            value: 0,
            unit: "px"
          },
          bottom:{
            value: 20,
            unit: "px"
          },
          right:{
            value: 0,
            unit: "px"
          }
        },
      },
      textFont: null,
      textSize: null,
      textWeight: null,
      textLineHeight: null,
      textLetterSpacing: null,
      textTransform: null,
    },
    variant: {
      "default":{
        borderColor: "transparent",
        boxShadow: "0px 3px 5px #0000000F",
        background: "#ffffff",
        bar: {
          background: null,
          textColor: "#ffd300",
          icon: {
            normal: {
              color: "#000000",
              background: null
            }
          }
        },
        content: {
          inforowVariant: "default",
          borderColor: "transparent",
          background: null,
          textColor: "#000000"
        }
      },
      "event":{
        borderColor: "transparent",
        boxShadow: "0px 3px 5px #0000000F",
        background: "#ffffff",
        bar: {
          background: null,
          textColor: "#ffd300",/*"#079192",*/
          icon: {
            normal: {
              color: "#ffd300",/*"#079192",*/
              background: null
            }
          }
        },
        content: {
          inforowVariant: "default",
          borderColor: "transparent",
          background: null,
          textColor: "#000000"
        }
      },
      "grey":{
        borderColor: "transparent",
        boxShadow: "0px 3px 5px #0000000F",
        background: "#DDDDDD",
        bar: {
          background: null,
          textColor: "#ffd300",
          icon: {
            normal: {
              color: "#ffd300",
              background: null
            }
          }
        },
        content: {
          inforowVariant: "default",
          borderColor: "transparent",
          background: null,
          textColor: "#ffd300"
        }
      },
      "event-grey":{
        borderColor: "transparent",
        boxShadow: "0px 3px 5px #0000000F",
        background: "#DDDDDD",
        bar: {
          background: null,
          textColor: "#ffd300",/*"#079192",*/
          icon: {
            normal: {
              color: "#ffd300",/*"#079192",*/
              background: null
            }
          }
        },
        content: {
          inforowVariant: "default",
          borderColor: "transparent",
          background: null,
          textColor: "#ffd300"/*"#079192"*/
        }
      },
      "dark":{
        borderColor: "transparent",
        boxShadow: "0px 3px 5px #0000000F",
        background: "#000000",
        bar: {
          background: null,
          textColor: "#ffffff",
          icon: {
            normal: {
              color: "#ffffff",
              background: null
            }
          }
        },
        content: {
          inforowVariant: "default",
          borderColor: "transparent",
          background: null,
          textColor: "#ffffff"
        }
      }
    }
  },
  post:{
    borderStyle: "solid",
    borderSize: 1,
    borderRadius: {
      value: 4,
      unit: "px"
    },
    padding:{
      [LAYOUT_XS]: {
        top:{
          value: 15,
          unit: "px"
        },
        left:{
          value: 15,
          unit: "px"
        },
        bottom:{
          value: 15,
          unit: "px"
        },
        right:{
          value: 15,
          unit: "px"
        }
      },
      [LAYOUT_SM]: {
        top:{
          value: 15,
          unit: "px"
        },
        left:{
          value: 15,
          unit: "px"
        },
        bottom:{
          value: 15,
          unit: "px"
        },
        right:{
          value: 15,
          unit: "px"
        }
      },
      [LAYOUT_MD]: {
        top:{
          value: 15,
          unit: "px"
        },
        left:{
          value: 15,
          unit: "px"
        },
        bottom:{
          value: 15,
          unit: "px"
        },
        right:{
          value: 15,
          unit: "px"
        }
      },
      [LAYOUT_LG]: {
        top:{
          value: 20,
          unit: "px"
        },
        left:{
          value: 20,
          unit: "px"
        },
        bottom:{
          value: 20,
          unit: "px"
        },
        right:{
          value: 20,
          unit: "px"
        }
      }
    },
    tags: {
      textFont: null,
      textSize: 11,
      textWeight: null,
      textLineHeight: null,
      textLetterSpacing: null,
      textTransform: null
    },
    title: {
      textFont: null,
      textSize: 15,
      textWeight: 700,
      textLineHeight: null,
      textLetterSpacing: null,
      textTransform: null
    },
    content: {
      textFont: null,
      textSize: 13,
      textWeight: null,
      textLineHeight: null,
      textLetterSpacing: null,
      textTransform: null
    },
    highlighted: {
      textFont: null,
      textSize: 13,
      textWeight: 700,
      textLineHeight: null,
      textLetterSpacing: null,
      textTransform: null
    },
    recommended: {
      textFont: null,
      textSize: 13,
      textWeight: 700,
      textLineHeight: null,
      textLetterSpacing: null,
      textTransform: null
    },
    footer: {
      textFont: null,
      textSize: 11,
      textWeight: null,
      textLineHeight: null,
      textLetterSpacing: null,
      textTransform: null,
      borderStyle: "solid",
      borderSize: 1
    },
    cta:{
      alignment: "left"
    },
    variant: {
      "default":{
        borderColor: "transparent",
        boxShadow: "0px 3px 5px #0000000F",
        background: "#ffffff",
        title: {
          textColor: "#000000"
        },
        content: {
          textColor: "#000000"
        },
        tags: {
          textColor: "#ffd300"
        },
        highlighted: {
          textColor: "#ffd300"
        },
        recommended: {
          textColor: "#ffd300"
        },
        footer: {
          textColor: "#000000",
          borderColor: "#d4d4d4",
        },
        buttonSize: "default",
        buttonVariant: "default-o"
      },
      "advertising":{
        borderColor: "#E5087E4B",
        boxShadow: "0px 3px 5px #0000000F",
        background: "#ffffff",
        title: {
          textColor: "#000000"
        },
        content: {
          textColor: "#000000"
        },
        tags: {
          textColor: "#ffd300"
        },
        highlighted: {
          textColor: "#ffd300"
        },
        recommended: {
          textColor: "#ffd300"
        },
        footer: {
          textColor: "#000000",
          borderColor: "#d4d4d4",
        },
        buttonSize: "default",
        buttonVariant: "default-o"
      },
    }
  },
  fullModal:{
    borderStyle: "solid",
    borderSize: 0,
    borderRadius: {
      value: 4,
      unit: "px"
    },
    padding:{
      [LAYOUT_XS]: {
        top:{
          value: 15,
          unit: "px"
        },
        left:{
          value: 15,
          unit: "px"
        },
        bottom:{
          value: 15,
          unit: "px"
        },
        right:{
          value: 15,
          unit: "px"
        }
      },
      [LAYOUT_SM]: {
        top:{
          value: 15,
          unit: "px"
        },
        left:{
          value: 15,
          unit: "px"
        },
        bottom:{
          value: 15,
          unit: "px"
        },
        right:{
          value: 15,
          unit: "px"
        }
      },
      [LAYOUT_MD]: {
        top:{
          value: 15,
          unit: "px"
        },
        left:{
          value: 15,
          unit: "px"
        },
        bottom:{
          value: 15,
          unit: "px"
        },
        right:{
          value: 15,
          unit: "px"
        }
      },
      [LAYOUT_LG]: {
        top:{
          value: 20,
          unit: "px"
        },
        left:{
          value: 20,
          unit: "px"
        },
        bottom:{
          value: 20,
          unit: "px"
        },
        right:{
          value: 20,
          unit: "px"
        }
      }
    },
    variant: {
      "default":{
        borderColor: "transparent",
        boxShadow: "0px 3px 5px #0000000F",
        background: "#ffffff"
      },
    }
  },

  mobileheader:{
    textFont: null,
    textSize: null,
    textWeight: 600,
    textLineHeight: null,
    textLetterSpacing: null,
    textTransform: null,
    textColor: "#000000",
    icon: {
      normal: {
        color: "#000000",
        background: "transparent"
      }
    }
  },
  infoRow:{
    bar: {
      borderStyle: "solid",
      borderSize: 1,
      height: {
        value: 60,
        unit: "px"
      },
      padding: {
        top: {
          value: 15,
          unit: "px"
        },
        left: {
          value: 0,
          unit: "px"
        },
        bottom: {
          value: 15,
          unit: "px"
        },
        right: {
          value: 0,
          unit: "px"
        }
      }
    },
    label: {
      textFont: null,
      textSize: 16,
      textWeight: 600,
      textLineHeight: null,
      textLetterSpacing: null,
      textTransform: null,
    },
    value: {
      textFont: null,
      textSize: 16,
      textWeight: 400,
      textLineHeight: null,
      textLetterSpacing: null,
      textTransform: null,
    },
    children:{
      padding: {
        top: {
          value: 15,
          unit: "px"
        },
        left: {
          value: 0,
          unit: "px"
        },
        bottom: {
          value: 30,
          unit: "px"
        },
        right: {
          value: 0,
          unit: "px"
        }
      },
      textFont: null,
      textSize: 16,
      textWeight: 400,
      textLineHeight: null,
      textLetterSpacing: null,
      textTransform: null,
    },
    variant: {
      "default": {
        bar: {
          borderColor: "#DDDDDDCC"
        },
        label: {
          textColor: "#000000"
        },
        value: {
          textColor: "#000000"
        },
        children: {
          textColor: "#000000"
        }
      },
      "event": {
        bar: {
          borderColor: "#ffd300"/*"#079192"*/
        },
        label: {
          textColor: "#ffd300"/*"#079192"*/
        },
        value: {
          textColor: "#000000"
        },
        children: {
          textColor: "#000000"
        }
      },
      "event-noborder": {
        bar: {
          borderColor: "#ffd300"/*"#079192"*/
        },
        label: {
          textColor: "#ffd300"/*"#079192"*/
        },
        value: {
          textColor: "#000000"
        },
        children: {
          textColor: "#000000"
        }
      }
    }
  },
  sheetTopbar:{
    bar: {
      borderStyle: "solid",
      borderSize: 0,
      height: {
        value: 60,
        unit: "px"
      },
      padding: {
        top: {
          value: 15,
          unit: "px"
        },
        left: {
          value: 0,
          unit: "px"
        },
        bottom: {
          value: 15,
          unit: "px"
        },
        right: {
          value: 0,
          unit: "px"
        }
      }
    },
    title: {
      textFont: null,
      textSize: null,
      textWeight: 400,
      textLineHeight: null,
      textLetterSpacing: null,
      textTransform: null,
    },
    variant: {
      "default": {
        anchorLinkVariant: "default",
        bar: {
          background: "#ffd300",
          boxShadow: "0px 3px 5px #0000000F",
          borderColor: "transparent"
        },
        title: {
          textColor: "#ffffff"
        }
      },
      "event": {
        anchorLinkVariant: "default",
        bar: {
          background: "#ffd300",/*"#079192",*/
          boxShadow: "0px 3px 5px #0000000F",
          borderColor: "transparent"
        },
        title: {
          textColor: "#ffffff"
        }
      }
    }
  },
  anchors:{
    spacing: 15,
    link: {

      textFont: null,
      textSize: null,
      textWeight: 400,
      textLineHeight: null,
      textLetterSpacing: null,
      textTransform: null,
    },
    variant: {
      "default": {
        link: {
          normal: {
            textColor: "#ffffff66"
          },
          hover: {
            textColor: "#ffffff"
          },
          active: {
            textColor: "#ffffff"
          }
        }
      }
    }
  },

  typography: {
    text: {
      textColor: "#000000",
      textFont: '"DIN", sans-serif',
      textSize: 16,
      textWeight: 400,
      textLineHeight: 18,
      textLetterSpacing: null,
      textTransform: null
    },
    h1: {
      textColor: "#000000",
      textFont: null,
      textSize: 50,
      textWeight: 400,
      textLineHeight: null,
      textLetterSpacing: null,
      textTransform: null
    },
    h2: {
      textColor: "#000000",
      textFont: null,
      textSize: 40,
      textWeight: 400,
      textLineHeight: null,
      textLetterSpacing: null,
      textTransform: null
    },
    h3: {
      textColor: "#000000",
      textFont: null,
      textSize: 16,
      textWeight: 400,
      textLineHeight: null,
      textLetterSpacing: null,
      textTransform: null
    }

  },
  button:{

    textFont: null,
    textLetterSpacing: null,
    textTransform: null,
    borderStyle: "solid",
    size: {
      "default": {
        textSize: 12,
        textWeight: 600,
        textLineHeight: null,
        borderSize: 2,
        borderRadius: {
          value: 100,
          unit: "px"
        },
        padding: {
          top:{
            value: 8,
            unit: "px"
          },
          left:{
            value: 20,
            unit: "px"
          },
          bottom:{
            value: 8,
            unit: "px"
          },
          right:{
            value: 20,
            unit: "px"
          }
        },
      },
      "tiny":{
        textSize: 12,
        textWeight: 400,
        textLineHeight: null,
        borderSize: 2,
        borderRadius: {
          value: 100,
          unit: "px"
        },
        padding: {
          top:{
            value: 4,
            unit: "px"
          },
          left:{
            value: 10,
            unit: "px"
          },
          bottom:{
            value: 4,
            unit: "px"
          },
          right:{
            value: 10,
            unit: "px"
          }
        },
      }
    },
    variant:{
      "default": {
        normal:{
          textColor: "#000000",
          borderColor: "#ffd300",
          background: "#ffd300"
        },
        hover:{
          textColor: "#000000",
          borderColor: "#ffd300",
          background: "#ffffff"
        },
        active:{
          textColor: "#000000",
          borderColor: "#ffd300",
          background: "#ffffff"
        },
        disabled:{
          textColor: "#dedede",
          borderColor: "#dedede",
          background: "#ffffff"
        }
      },
      "event": {
        normal:{
          textColor: "#ffffff",
          borderColor: "#ffd300",/*"#079192",*/
          background: "#ffd300"/*"#079192"*/
        },
        hover:{
          textColor: "#ffd300",/*"#079192",*/
          borderColor: "#ffd300",/*"#079192",*/
          background: "#ffffff"
        },
        active:{
          textColor: "#ffd300",/*"#079192",*/
          borderColor: "#ffd300",/*"#079192",*/
          background: "#ffffff"
        },
        disabled:{
          textColor: "#dedede",
          borderColor: "#dedede",
          background: "#ffffff"
        }
      },
      "default-inverse": {
        normal:{
          textColor: "#ffd300",
          borderColor: "#ffffff",
          background: "#ffffff"
        },
        hover:{
          textColor: "#ffffff",
          borderColor: "#ffffff",
          background: "#ffd300"
        },
        active:{
          textColor: "#ffffff",
          borderColor: "#ffffff",
          background: "#ffd300"
        },
        disabled:{
          textColor: "#dedede",
          borderColor: "#dedede",
          background: "#ffffff"
        }
      },
      "default-o": {
        normal:{
          textColor: "#ffd300",
          borderColor: "#ffd300",
          background: "#ffffff"
        },
        hover:{
          textColor: "#ffffff",
          borderColor: "#ffd300",
          background: "#ffd300"
        },
        active:{
          textColor: "#ffffff",
          borderColor: "#ffd300",
          background: "#ffd300"
        },
        disabled:{
          textColor: "#dedede",
          borderColor: "#dedede",
          background: "#ffffff"
        }
      },
      "default-inverse-o": {
        normal:{
          textColor: "#ffffff",
          borderColor: "#ffffff",
          background: "#ffd300"
        },
        hover:{
          textColor: "#ffd300",
          borderColor: "#ffffff",
          background: "#ffffff"
        },
        active:{
          textColor: "#ffd300",
          borderColor: "#ffffff",
          background: "#ffffff"
        },
        disabled:{
          textColor: "#dedede",
          borderColor: "#dedede",
          background: "#ffd300"
        }
      },
      "black-o": {
        normal:{
          textColor: "#000000",
          borderColor: "#000000",
          background: "#ffd300"
        },
        hover:{
          textColor: "#ffd300",
          borderColor: "#000000",
          background: "#000000"
        },
        active:{
          textColor: "#ffd300",
          borderColor: "#000000",
          background: "#000000"
        },
        disabled:{
          textColor: "#dedede",
          borderColor: "#dedede",
          background: "#ffd300"
        }
      },
      "event-o": {
        normal:{
          textColor: "#ffd300",/*"#079192",*/
          borderColor: "#ffd300",/*"#079192",*/
          background: "#ffffff"
        },
        hover:{
          textColor: "#ffffff",
          borderColor: "#ffd300",/*"#079192",*/
          background: "#ffd300"/*"#079192"*/
        },
        active:{
          textColor: "#ffffff",
          borderColor: "#ffd300",/*"#079192",*/
          background: "#ffd300"/*"#079192"*/
        },
        disabled:{
          textColor: "#dedede",
          borderColor: "#dedede",
          background: "#ffffff"
        }
      },
      "subareas": {
        normal:{
          textColor: "#000000",
          borderColor: "#ffffff",
          background: "#ffffff"
        },
        hover:{
          textColor: "#000000",
          borderColor: "#ffd300",
          background: "#ffd300"
        },
        active:{
          textColor: "#000000",
          borderColor: "#ffd300",
          background: "#ffd300"
        },
        disabled:{
          textColor: "#dedede",
          borderColor: "#4D4D4D",
          background: "#4D4D4D"
        }
      },
    }
  },
  labelledValue: {
    textFont: null,
    textSize: 15,
    textWeight: 700,
    textLineHeight: null,
    textLetterSpacing: null,
    textTransform: "uppercase",
    borderSize: 1,
    borderStyle: "solid",
    variant:{
      "default": {
        textColor: "#ffd300",
        borderColor: "#ffd300"
      }
    }

  },
  badge:{
    padding: {
      top:{
        value: 2,
        unit: "px"
      },
      left:{
        value: 10,
        unit: "px"
      },
      bottom:{
        value: 2,
        unit: "px"
      },
      right:{
        value: 10,
        unit: "px"
      }
    },
    textFont: '"DIN", sans-serif',
    textSize: 14,
    textWeight: 800,
    textLineHeight: null,
    textLetterSpacing: null,
    textTransform: "uppercase",
    borderSize: 0,
    borderStyle: "solid",
    borderRadius: {
      value: 4,
      unit: "px"
    },
    variant:{
      "default": {
        textColor: "#000000",
        borderColor: "transparent",
        background: "#F2F4F4"
      },
      "event": {
        textColor: "#ffd300",/*"#079192",*/
        borderColor: "transparent",
        background: "#ffd30017"/*"#07919217"*/
      },
      "filter": {
        textColor: "#000000",
        borderColor: "transparent",
        background: "#ffd300"
      },
      "primary": {
        textColor: "#000000",
        borderColor: "transparent",
        background: "#ffd300"
      }
    }
  },

  menuitem:{

    textFont: null,
    textTransform: null,


    size: {
      "default": {
        textSize: 18,
        textWeight: 600,
        textLineHeight: null,
        textLetterSpacing: null,
        borderSize: 1,
        borderStyle: "solid",
        height:{
          value: 60,
          unit: "px"
        },
        iconSize: {
          value: 22,
          unit: "px"
        },
        padding: {
          top:{
            value: 15,
            unit: "px"
          },
          left:{
            value: 20,
            unit: "px"
          },
          bottom:{
            value: 15,
            unit: "px"
          },
          right:{
            value: 20,
            unit: "px"
          }
        },
      },
      "tiny":{
        textSize: 14,
        textWeight: 600,
        textLineHeight: null,
        textLetterSpacing: null,
        borderSize: 0,
        borderStyle: "solid",
        height:{
          value: 30,
          unit: "px"
        },
        iconSize: {
          value: 10,
          unit: "px"
        },
        padding: {
          top:{
            value: 15,
            unit: "px"
          },
          left:{
            value: 20,
            unit: "px"
          },
          bottom:{
            value: 15,
            unit: "px"
          },
          right:{
            value: 20,
            unit: "px"
          }
        },
      }
    },
    variant:{
      "default": {
        normal:{
          textColor: "#ffffff",
          background: "#202128;",
          borderColor: "#4D4D4D"
        },
        hover:{
          textColor: "#FFD300",
          background: "#202128;",
          borderColor: "#4D4D4D"
        },
        active:{
          textColor: "#FFD300",
          background: "#202128;",
          borderColor: "#4D4D4D"
        },
        disabled:{
          textColor: "#999999",
          background: "#202128;",
          borderColor: "#4D4D4D"
        }
      },
      "grey": {
        normal:{
          textColor: "#000000",
          background: "#F2F4F4",
          borderColor: "transparent"
        },
        hover:{
          textColor: "#000000",
          background: "#F2F4F4",
          borderColor: "transparent"
        },
        active:{
          textColor: "#000000",
          background: "#F2F4F4",
          borderColor: "transparent"
        },
        disabled:{
          textColor: "#999999",
          background: "#F2F4F4",
          borderColor: "transparent"
        }
      },
      "black": {
        normal:{
          textColor: "#ffffff",
          background: "#282930",
          borderColor: "#4D4D4D"
        },
        hover:{
          textColor: "#FFD300",
          background: "#282930",
          borderColor: "#4D4D4D"
        },
        active:{
          textColor: "#FFD300",
          background: "#282930",
          borderColor: "#4D4D4D"
        },
        disabled:{
          textColor: "#999999",
          background: "#282930",
          borderColor: "#4D4D4D"
        }
      },
      "inverse": {
        normal:{
          textColor: "#ffffff",
          background: "#ffd300",
          borderColor: "transparent"
        },
        hover:{
          textColor: "#ffffff",
          background: "#ffd300",
          borderColor: "transparent"
        },
        active:{
          textColor: "#ffffff",
          background: "#ffd300",
          borderColor: "transparent"
        },
        disabled:{
          textColor: "#999999",
          background: "#ffd300",
          borderColor: "transparent"
        }
      },
      "filter": {
        normal:{
          textColor: "#ffffff",
          background: "transparent",
          borderColor: "#4D4D4D"
        },
        hover:{
          textColor: "#ffd300",
          background: "transparent",
          borderColor: "#4D4D4D"
        },
        active:{
          textColor: "#ffd300",
          background: "transparent",
          borderColor: "#4D4D4D"
        },
        disabled:{
          textColor: "#999999",
          background: "transparent",
          borderColor: "#4D4D4D"
        }
      },
      "homepage": {
        normal:{
          textColor: "#A3A3A3",
          background: "transparent",
          borderColor: "transparent"
        },
        hover:{
          textColor: "#ffd300",
          background: "transparent",
          borderColor: "transparent"
        },
        active:{
          textColor: "#ffd300",
          background: "transparent",
          borderColor: "transparent"
        },
        disabled:{
          textColor: "#999999",
          background: "transparent",
          borderColor: "transparent"
        }
      },
    }
  },
  colors: {
    primary: '#ffd300'
  }
};
